import { DrawerClose, DrawerTitle, DrawerHeader } from '@/components/ui/drawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  CreateTermineFormContent,
  CreateTermineSubmitButton,
} from '@/domain/termine/features/CreateTermin/shared';
import { Button } from '@/components/ui/button';

export function CreateTermineDrawer() {
  const { t } = useTranslation();

  return (
    <>
      <DrawerHeader className="sticky top-0 z-10 bg-neutrals-N200 border-b border-neutrals-N300 shrink-0">
        <DrawerTitle className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <DrawerClose asChild>
              <Button variant="ghost" size="icon">
                <FontAwesomeIcon
                  className="text-primary-blue-B500"
                  icon={faArrowLeft}
                  fixedWidth
                />
              </Button>
            </DrawerClose>
            <span className="text-sm text-neutrals-N800">
              {t('domain.termine.sheet.neuerTermin')}
            </span>
          </div>
          <CreateTermineSubmitButton variant="drawer" />
        </DrawerTitle>
      </DrawerHeader>

      <div className="flex-1 overflow-y-auto overscroll-contain">
        <CreateTermineFormContent />
      </div>
    </>
  );
}
